// extracted by mini-css-extract-plugin
export var quantityInput = "_n5-0";